<template>
  <ValidationObserver>
    <label for="booking.unit">{{ $t('keypad') }}</label>
    <div class="form-group" v-if="booking.nuki && booking.nuki.keypadCode" style="display: flex; align-items: center;">
      <input class="form-control" disabled="true" v-bind:value="booking.nuki.keypadCode">
      <button type="button" class="btn btn-primary sendCodeToNuki" @click="sendCodeToNuki('createCode')" :disabled="codeButtonDisabled">Create</button>
      <button type="button" class="btn btn-danger deleteCodeOnNuki" @click="sendCodeToNuki('deleteCode')" :disabled="codeButtonDisabled">Delete</button>
    </div>
    <div class="form-group">
      <label for="booking.room">{{ $t('room') }}</label>
      <ValidationProvider name="room" vid="booking.room" rules="required" v-slot="{ errors }">
        <select class="form-control" v-model="booking.room._id" :class="{ 'is-invalid': errors[0] }">
          <option value="" disabled></option>
          <option v-for="room in rooms" v-bind:value="room._id">{{room.name}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <!--<div class="form-group">
      <label for="booking.unit">{{ $t('unit') }}</label>
      <ValidationProvider name="unit" vid="unit" rules="required" v-slot="{ errors }">
        <select class="form-control" v-model="booking.unitId" :disabled="!booking.room" :class="{ 'is-invalid': errors[0] }">
          <option value="" disabled></option>
          <option v-for="(unit, index) in units" v-bind:value="index + 1">{{unit.name}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>-->

    <div class="form-group" v-if="selectedRoom.quantity">
      <label for="booking.unit">{{ $t('unit') }}</label>
      <ValidationProvider name="unit" vid="booking.unitId" rules="required" v-slot="{ errors }">
        <select class="form-control" v-model="booking.unitId" :disabled="!booking.room" :class="{ 'is-invalid': errors[0] }">
          <option value="" disabled></option>
          <!--<option v-for="(unit, index) in units" v-bind:value="index + 1">{{unit.name}}</option>-->

          <option v-for="index in selectedRoom.quantity" v-bind:value="index">
            {{ selectedRoom.units && selectedRoom.units[index - 1] ? selectedRoom.units[index - 1].name : index }}
          </option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label for="booking.check.in">{{ $t('checkIn') }}</label>
      <ValidationProvider name="check in" vid="booking.night.first" rules="required" v-slot="{ errors }">
        <date-picker :input-props='{
                       class: "form-control " + (errors[0] ? "is-invalid" : ""),
                       disabled: booking.referer && booking.referer.channel && booking.referer.channel != "Hostomate.com" ? "true" : false
                     }'
                     :firstDayOfWeek="2"
                     v-model="booking.check.in"
                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                     >
        </date-picker>

        <!--<input class="form-control" v-model="booking.check.in" :class="{ 'is-invalid': errors[0] }" :disabled="booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com'">-->
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="booking.check.out">{{ $t('checkOut') }}</label>
      <ValidationProvider name="check out" vid="booking.night.last" rules="required" v-slot="{ errors }">
        <date-picker :input-props='{
                       class: "form-control " + (errors[0] ? "is-invalid" : ""),
                       disabled: booking.referer && booking.referer.channel && booking.referer.channel != "Hostomate.com" ? "true" : false
                     }'
                     :firstDayOfWeek="2"
                     v-model="booking.check.out"
                     :popover="{ placement: 'bottom', visibility: 'click', 'expanded': true }"
                     >
        </date-picker>
        <!--<input class="form-control" v-model="booking.check.out" :class="{ 'is-invalid': errors[0] }" :disabled="booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com'">-->
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <!--<div class="form-group">
      <label for="booking.night.first">First night</label>
      <ValidationProvider name="first night" vid="booking.night.first" rules="required" v-slot="{ errors }">
        <input class="form-control" v-model="booking.night.first" :class="{ 'is-invalid': errors[0] }" :disabled="booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com'">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="booking.night.last">Last night</label>
      <ValidationProvider name="last night" vid="booking.night.last" rules="required" v-slot="{ errors }">
        <input class="form-control" v-model="booking.night.last" :class="{ 'is-invalid': errors[0] }" :disabled="booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com'">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>-->
    <div class="form-group">
      <label for="booking.price">{{ $t('price') }}</label>
      <ValidationProvider name="price" vid="booking.price" rules="required" v-slot="{ errors }">
        <input class="form-control" v-model="booking.price" :class="{ 'is-invalid': errors[0] }" type="number" step=".01" :disabled="booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com'" min="0">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="booking.numGuests.adults">{{ $t('adults') }}</label>
      <ValidationProvider name="number of adults" vid="booking.numGuests.adults" rules="required" v-slot="{ errors }">
        <select class="form-control disabled" v-model="booking.numGuests.adults" :disabled="!booking.room || (booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com')">
          <option value=""></option>
          <option value="0">0</option>
          <option v-for="i in maxGuests" v-bind:value="i" :disabled="maxGuests - booking.numGuests.children < i">{{i}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="booking.numGuests.childred">{{ $t('children') }}</label>
      <ValidationProvider name="number of children" vid="booking.numGuests.children" rules="required" v-slot="{ errors }">
        <select class="form-control disabled" v-model="booking.numGuests.children" :disabled="!booking.room || (booking.referer && booking.referer.channel && booking.referer.channel != 'Hostomate.com')">
          <option value=""></option>
          <option value="0">0</option>
          <option v-for="i in maxGuests" v-bind:value="i" :disabled="maxGuests - booking.numGuests.adults < i">{{i}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
const moment = require('moment');

export default {
  name: 'Booking',
  props: ['booking', 'rooms', 'maxGuests', 'socket'],
  data() {
    return {
      codeButtonDisabled: false
    };
  },
  components: {
    DatePicker
  },
  computed: {
    selectedRoom: function() {
      let room = this.rooms.find(r => r._id == this.booking.room._id);
      if(room) return room;
      return {
        quantity: 0,
        units: []
      }
    }
  },
  watch: {
    'booking.room._id': function(val, oldVal) {
      //this.booking.unitId = "";
    },
    'booking.check.in': function(val, oldVal) {
      this.booking.night.first = moment(val).format('YYYY-MM-DD')
    },
    'booking.check.out': function(val, oldVal) {
      this.booking.night.last = moment(val).subtract(1, 'days').format('YYYY-MM-DD')
    }
  },
  methods: {
    async sendCodeToNuki(action) {
      try {
        // Assuming you have access to the bookingId
        const bookingId = this.booking._id;
        // Make an API call to invoke the postNuki function
        await this.invokePostNuki(bookingId, action);

        // Optionally, show a success message or perform other actions
        // console.log('Tried to send the code to Nuki');
      } catch (error) {
        console.error('Error sending code to Nuki:', error);
        // Optionally, show an error message or perform other actions
      }
    },

    async invokePostNuki(bookingId, action) {
      this.codeButtonDisabled= true;
      fetch(`${process.env.VUE_APP_API}/bookings/${bookingId}/sendCodeToNuki`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          _id: bookingId,
          action: action,
          socket: {
            id: this.socket.id
          }
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        this.codeButtonDisabled = false;
        return response.json();
      })
      .then(data => {
        // Handle successful response
        this.codeButtonDisabled = false;
        // console.log('Code sent successfully to Nuki:', data);
      })
      .catch(error => {
        this.codeButtonDisabled = false;
        console.error('There was an error with the fetch operation:', error);
      });
    }
  }
}
</script>


<i18n>
{
  "en": {
    "keypad": "Entry Code",
    "room": "Room type",
    "unit": "Unit",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "price": "Price",
    "adults": "Number of Adults",
    "children": "Number of Children"
  },
  "sl": {
    "keypad": "Številka ključavnice",
    "room": "Tip sobe",
    "unit": "Enota",
    "checkIn": "Prihod",
    "checkOut": "Odhod",
    "price": "Cena",
    "adults": "Število odraslih",
    "children": "Število otrok"
  }
}
</i18n>
